export const authAction = {
    SET_AUTH: "SET_AUTH",
    REMOVE_AUTH: "REMOVE_AUTH",
};